import {connect} from 'react-redux';
import EventPriceDetailsModal from './EventPriceDetailsModal.jsx';
import {cancelEventPriceDetailModal} from './actionTypes';

const mapStateToProps = state => ({
  visible: state.shared.eventPriceDetailsModal.showEventPriceDetailsModal,
  ...state.shared.eventPriceDetailsModal.eventPriceDetailsData
});

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(cancelEventPriceDetailModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(EventPriceDetailsModal);



// WEBPACK FOOTER //
// ./src/features/shared/eventPriceDetailsModal/EventPriceDetailsModalContainer.jsx